import { render, staticRenderFns } from "./resolveDispute.vue?vue&type=template&id=e9b72206&scoped=true"
import script from "./resolveDispute.vue?vue&type=script&lang=js"
export * from "./resolveDispute.vue?vue&type=script&lang=js"
import style0 from "./resolveDispute.vue?vue&type=style&index=0&id=e9b72206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b72206",
  null
  
)

export default component.exports